// extracted by mini-css-extract-plugin
export var closeButton = "_n7-2";
export var closeButtonIcon = "_n7-3";
export var lightboxContent = "_n7-1";
export var lightboxOverlay = "_n7-0";